import { LegalDocument } from "@/features/legal/components/LegalDocument";

export function LegalNoticePage() {
  return <LegalDocument document="notice" />;
}
